import { render, staticRenderFns } from "./importExcel.vue?vue&type=template&id=2ff6eb84&scoped=true&"
import script from "./importExcel.vue?vue&type=script&lang=js&"
export * from "./importExcel.vue?vue&type=script&lang=js&"
import style0 from "./importExcel.vue?vue&type=style&index=0&id=2ff6eb84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6eb84",
  null
  
)

export default component.exports